import {
  AdjustmentsIcon,
  ArchiveIcon,
  ArrowCircleUpIcon,
  PencilIcon,
  PhotographIcon,
  TrashIcon,
} from '@heroicons/react/solid';
import React from 'react';

const PlantButtons = (props) => {
  return (
    <div className="flex mt-5 mb-2 justify-end">
      {!props.archived && (
        <>
          <button
            type="button"
            onClick={() => props.setEditPlant(props.plant)}
            className="text-gray-500 hover:text-gray-700 mr-2"
          >
            <PencilIcon className="w-5 h-5" />
          </button>
          <button
            type="button"
            onClick={() => props.setDropDownPlantId(props.plant.id)}
            className="text-gray-500 hover:text-gray-700 mr-2"
          >
            <AdjustmentsIcon className="w-5 h-5" />
          </button>
          <label className="text-gray-500 hover:text-gray-700 mr-2">
            <PhotographIcon className="w-5 h-5" />
            <input
              type="file"
              className="hidden"
              id="file"
              name="file"
              onChange={(e) => props.uploadFile(e, props.plant)}
            />
          </label>
        </>
      )}
      <button
        type="button"
        onClick={() => props.archivePlant(props.plant.id)}
        className={
          props.archived
            ? 'text-accent-500 hover:text-accent-700'
            : 'text-red-500 hover:text-red-700'
        }
      >
        {props.archived ? (
          <ArrowCircleUpIcon className="w-5 h-5" />
        ) : (
          <ArchiveIcon className="w-5 h-5" />
        )}
      </button>
      {props.archived && props.allowDelete && (
        <button
          type="button"
          onClick={() => props.deletePlant(props.plant)}
          className="text-red-500 hover:text-red-700 ml-2"
        >
          <TrashIcon className="w-5 h-5" />
        </button>
      )}
    </div>
  );
};

export default PlantButtons;
